let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([require("./helpers/browser/css-loader")(require('./helpers/bundle-manifest').resolve("lwIOz")), load("ipaD6")]).then(() => parcelRequire('atQfO'));